module.exports = __webpack_public_path__ + "static/media/EMPOWER_Logo-v1.1.061ed655.png";